import { atom } from 'recoil'

export const memoTypeState = atom({
    key: 'memo-types',
    default: [],
})
